import React, { useState, useEffect } from 'react';
import { Button, Card, Table, Modal, Form, Row, Col, Alert, Spinner } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import "../../../scss/belts.css";

export default function PraticantesUser() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const [praticantes, setPraticantes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isCreating, setIsCreating] = useState(false);
    const [currentPraticante, setCurrentPraticante] = useState({});
    const [search, setSearch] = useState("");
    const [showOnlyActive, setShowOnlyActive] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [fotoPreview, setFotoPreview] = useState(null);
    const [isProcessingFoto, setIsProcessingFoto] = useState(false);

    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    // Proteção caso o token não exista ou seja inválido
    let decoded = {};
    try {
        if (token) decoded = jwtDecode(token);
    } catch (e) {
        console.error("Token inválido");
    }
    const GRADUACOES = [
        { value: 0, nome: "9º Kyu", cor: "Branco", className: "belt-white" },
        { value: 1, nome: "8º Kyu", cor: "Amarelo", className: "belt-yellow" },
        { value: 2, nome: "7º Kyu", cor: "Laranja", className: "belt-orange" },
        { value: 3, nome: "6º Kyu", cor: "Verde", className: "belt-green" },
        { value: 4, nome: "5º Kyu", cor: "Azul", className: "belt-blue" },
        { value: 5, nome: "4º Kyu", cor: "Vermelho", className: "belt-red" },
        { value: 6, nome: "3º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 7, nome: "2º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 8, nome: "1º Kyu", cor: "Castanho", className: "belt-brown" },
        ...Array.from({ length: 10 }, (_, i) => ({
            value: 9 + i,
            nome: `${i + 1}º Dan`,
            cor: "Preto",
            className: "belt-black"
        }))
    ];

    const getGraduacaoInfo = (value) => GRADUACOES.find(g => g.value === value);

    const fetchPraticantes = async () => {
        const res = await fetch(`${API_BASE_URL}/praticantes`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        if (res.ok) {
            const data = await res.json();
            setPraticantes(data);
        }
    };

    useEffect(() => { fetchPraticantes(); }, []);

    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) return "—";
        const nascimento = new Date(dataNascimento);
        const hoje = new Date();
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const m = hoje.getMonth() - nascimento.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) idade--;
        return idade;
    };

    const handleFotoChange = e => {
        const file = e.target.files[0];
        if (!file) return;
        setCurrentPraticante({ ...currentPraticante, fotografia: file });
        setFotoPreview(URL.createObjectURL(file));
    };

    const getFotografiaBase64 = file => new Promise((resolve, reject) => {
        // Se não houver ficheiro NOVO selecionado (e.target.files[0])
        // retornamos a string base64 que já existia no objeto ou null
        if (!file || typeof file === 'string') {
            return resolve(currentPraticante.fotografia || null);
        }

        setIsProcessingFoto(true);
        const reader = new FileReader();
        reader.onload = () => {
            setIsProcessingFoto(false);
            // Remove o prefixo data:image/... para o C# aceitar como byte[]
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = err => {
            setIsProcessingFoto(false);
            reject(err);
        };
        reader.readAsDataURL(file);
    });

    const handleSave = async (e) => {
        e.preventDefault();
        if (isProcessingFoto) return;

        // Garante que temos o ID para a URL
        const praticanteId = currentPraticante.id;

        const url = isCreating
            ? `${API_BASE_URL}/praticantes`
            : `${API_BASE_URL}/praticantes/${praticanteId}`;

        try {
            const fotografiaBase64 = await getFotografiaBase64(currentPraticante.fotografia);

            const dataToSend = {
                // Se for edição, precisamos de enviar o ID no Body também
                id: isCreating ? 0 : praticanteId,

                utilizadorId: isCreating ? (parseInt(decoded.id) || 0) : currentPraticante.utilizadorId,
                isAtivo: currentPraticante.isAtivo,
                nome: currentPraticante.nome,
                dataNascimento: currentPraticante.dataNascimento,
                sexo: currentPraticante.sexo,
                telefone: parseInt(currentPraticante.telefone) || 0,

                // Garantir que enviamos apenas a string limpa
                fotografia: fotografiaBase64,

                // ... restantes campos (nif, email, etc)
                graduacao: currentPraticante.graduacao !== "" ? parseInt(currentPraticante.graduacao) : 0,
                nif: currentPraticante.nif ? parseInt(currentPraticante.nif) : null,
                cc: currentPraticante.cc || null,
                email: currentPraticante.email || null,
                morada: currentPraticante.morada || null,
                localidade: currentPraticante.localidade || null,
                cp: currentPraticante.cp || null,
                nacionalidade: currentPraticante.nacionalidade || "Portuguesa",
                naturalidade: currentPraticante.naturalidade || null,
                n_CPK: currentPraticante.n_CPK ? parseInt(currentPraticante.n_CPK) : null,
                n_Federacao: currentPraticante.n_Federacao ? parseInt(currentPraticante.n_Federacao) : null,
            };

            const res = await fetch(url, {
                method: isCreating ? "POST" : "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(dataToSend)
            });

            if (res.ok) {
                setSuccess(isCreating ? "Inscrição submetida!" : "Dados atualizados!");
                setShowModal(false);
                fetchPraticantes();
            } else {
                const errorData = await res.json().catch(() => ({}));
                setError(errorData.errors ? Object.values(errorData.errors).flat()[0] : "Erro na validação dos dados.");
            }
        } catch (err) {
            console.error("Erro no PUT:", err);
            setError("Erro ao processar o pedido. Verifique a consola.");
        }
    };

    const handleShowModal = (praticante, editar = false, criar = false) => {
        const formattedPraticante = {
            ...praticante,
            // Proteção contra datas nulas
            dataNascimento: praticante?.dataNascimento
                ? moment(praticante.dataNascimento).format('YYYY-MM-DD')
                : ''
        };

        setCurrentPraticante(formattedPraticante);

        // Se já tem foto, mostramos. Se não, limpamos o preview.
        if (praticante?.fotografia && typeof praticante.fotografia === 'string') {
            setFotoPreview(`data:image/png;base64,${praticante.fotografia}`);
        } else {
            setFotoPreview(null);
        }

        setIsEditing(editar);
        setIsCreating(criar);
        setShowModal(true);
    };

    const praticantesFiltrados = praticantes
        .filter(p =>
            p.nome?.toLowerCase().includes(search.toLowerCase()) &&
            (!showOnlyActive || p.isAtivo === 1)
        );

    const InfoItem = ({ label, value }) => (
        <div className="mb-2">
            <small className="text-muted">{label}</small>
            <div className="fw-semibold">{value || "—"}</div>
        </div>
    );

    // ... (mantenha o código anterior de funções e estados até ao return)

    return (
        <>
            {/* ===== HEADER ===== */}
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-start py-4">
                <div>
                    <h1 className="h4 mb-1">Os Meus Praticantes</h1>
                    <p className="mb-0 text-muted">Consulte e altere a informação dos seus praticantes.</p>
                </div>
                <Button
                    variant="primary"
                    onClick={() => handleShowModal({
                        nome: "", dataNascimento: "", sexo: "", telefone: "",
                        email: "", morada: "", localidade: "", cp: "",
                        nacionalidade: "Portuguesa", naturalidade: "", isAtivo: 0, graduacao: 0
                    }, false, true)}
                >
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Criar Praticante
                </Button>
            </div>

            {success && <Alert variant="success" onClose={() => setSuccess("")} dismissible>{success}</Alert>}
            {error && <Alert variant="danger" onClose={() => setError("")} dismissible>{error}</Alert>}

            {/* ===== FILTROS ===== */}
            <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} sm={6}>
                    <Form.Control
                        placeholder="Pesquisar por nome..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </Col>
                <Col xs={6} sm={3} className="d-flex align-items-center gap-2">
                    <Form.Check
                        type="checkbox"
                        id="checkAtivo"
                        label="Apenas ativos"
                        checked={showOnlyActive}
                        onChange={e => setShowOnlyActive(e.target.checked)}
                    />
                </Col>
            </Row>

            {/* ===== TABELA — desktop ===== */}
            <div className="d-none d-md-block">
                <Card border="light" className="shadow-sm">
                    <Card.Body className="p-0">
                        <Table hover responsive className="align-items-center mb-0">
                            <thead className="thead-light">
                            <tr>
                                <th style={{ width: 50 }}>Foto</th>
                                <th>Nome</th>
                                <th>Estado</th>
                                <th>Idade</th>
                                <th>Graduação</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {praticantesFiltrados.map(p => {
                                const g = getGraduacaoInfo(p.graduacao);
                                const isAtivo = p.isAtivo === 1 || p.isAtivo === true;
                                return (
                                    <tr key={p.id}>
                                        <td>
                                            <div className="rounded-circle border shadow-sm d-flex align-items-center justify-content-center overflow-hidden"
                                                style={{ width: 40, height: 40, backgroundColor: "#f0f0f0" }}>
                                                {p.fotografia ? (
                                                    <img src={`data:image/png;base64,${p.fotografia}`} alt="Perfil"
                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                ) : (
                                                    <span className="text-muted" style={{ fontSize: 14, fontWeight: 700 }}>
                                                        {p.nome?.charAt(0).toUpperCase()}
                                                    </span>
                                                )}
                                            </div>
                                        </td>
                                        <td className="fw-bold">{p.nome}</td>
                                        <td>
                                            <span className={`badge bg-${isAtivo ? "success" : "warning"}`}>
                                                {isAtivo ? "Ativo" : "Aguarda aprovação"}
                                            </span>
                                        </td>
                                        <td>{calcularIdade(p.dataNascimento)} anos</td>
                                        <td>
                                            {g ? <span className={`belt-badge ${g.className}`}>{g.nome}</span> : "—"}
                                        </td>
                                        <td>
                                            <div className="d-flex gap-1">
                                                <Button variant="outline-primary" size="sm"
                                                    onClick={() => handleShowModal(p, false, false)}>
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Button>
                                                <Button variant="outline-secondary" size="sm"
                                                    onClick={() => handleShowModal(p, true, false)}>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            {praticantesFiltrados.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-4">
                                        Nenhum praticante encontrado.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* ===== CARDS — mobile ===== */}
            <div className="d-md-none">
                {praticantesFiltrados.length === 0 ? (
                    <div style={{
                        textAlign: "center", padding: "48px 20px",
                        background: "white", borderRadius: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    }}>
                        <p className="text-muted mb-0 fw-bold">Nenhum praticante encontrado.</p>
                    </div>
                ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        {praticantesFiltrados.map(p => {
                            const g = getGraduacaoInfo(p.graduacao);
                            const isAtivo = p.isAtivo === 1 || p.isAtivo === true;
                            return (
                                <div
                                    key={p.id}
                                    style={{
                                        display: "flex", alignItems: "center", gap: 14,
                                        background: "white", borderRadius: 14, padding: "14px 16px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                                        border: "1px solid #f0f0f5",
                                    }}
                                >
                                    {/* Avatar */}
                                    <div style={{
                                        width: 52, height: 52, minWidth: 52, borderRadius: "50%",
                                        overflow: "hidden", border: "2px solid #e9ecef",
                                        backgroundColor: "#f0f0f5",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        flexShrink: 0,
                                    }}>
                                        {p.fotografia ? (
                                            <img src={`data:image/png;base64,${p.fotografia}`} alt={p.nome}
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                        ) : (
                                            <span style={{ fontSize: 20, fontWeight: 800, color: "#1e1d45" }}>
                                                {p.nome?.charAt(0).toUpperCase()}
                                            </span>
                                        )}
                                    </div>

                                    {/* Info */}
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{
                                            fontWeight: 700, fontSize: 15, color: "#1e1d45",
                                            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                        }}>
                                            {p.nome}
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                                            <span className={`badge bg-${isAtivo ? "success" : "warning"}`} style={{ fontSize: 10 }}>
                                                {isAtivo ? "Ativo" : "Pendente"}
                                            </span>
                                            {g && (
                                                <span className={`belt-badge ${g.className}`} style={{ fontSize: 10 }}>
                                                    {g.nome}
                                                </span>
                                            )}
                                            <span style={{ fontSize: 12, color: "#adb5bd" }}>
                                                {calcularIdade(p.dataNascimento)} anos
                                            </span>
                                        </div>
                                    </div>

                                    {/* Ações */}
                                    <div style={{ display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 }}>
                                        <button
                                            onClick={() => handleShowModal(p, false, false)}
                                            style={{
                                                width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6",
                                                background: "white", cursor: "pointer", display: "flex",
                                                alignItems: "center", justifyContent: "center", color: "#0d6efd",
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faEye} size="sm" />
                                        </button>
                                        <button
                                            onClick={() => handleShowModal(p, true, false)}
                                            style={{
                                                width: 36, height: 36, borderRadius: 8, border: "1px solid #dee2e6",
                                                background: "white", cursor: "pointer", display: "flex",
                                                alignItems: "center", justifyContent: "center", color: "#6c757d",
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faEdit} size="sm" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* ===== MODAL ===== */}
            <Modal
                centered
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                scrollable
            >
                <Modal.Header closeButton style={{ borderBottom: "none", paddingBottom: 0 }}>
                    <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>
                        {isCreating ? "Novo Praticante" : isEditing ? "Editar Praticante" : "Perfil do Praticante"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ paddingTop: 8 }}>
                    {isCreating && (
                        <Alert variant="info" className="mb-4" style={{ borderRadius: 10, fontSize: 13 }}>
                            <strong>Nota:</strong> O perfil ficará em estado <em>"Aguarda aprovação"</em> até ser validado pela secretaria.
                        </Alert>
                    )}

                    {/* ===== MODO VISUALIZAÇÃO ===== */}
                    {!isEditing && !isCreating && (
                        <>
                            {/* Hero do perfil */}
                            <div style={{
                                background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)",
                                borderRadius: 12, padding: "24px 20px 20px",
                                marginBottom: 24,
                            }}>
                                <Row className="align-items-center g-3">
                                    <Col xs={12} sm="auto" className="text-center text-sm-start">
                                        <div style={{
                                            width: 88, height: 88, borderRadius: "50%",
                                            overflow: "hidden", border: "3px solid rgba(255,255,255,0.3)",
                                            backgroundColor: "rgba(255,255,255,0.1)",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            margin: "0 auto",
                                        }}>
                                            {fotoPreview ? (
                                                <img src={fotoPreview} alt="Perfil" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                            ) : (
                                                <span style={{ fontSize: 36, fontWeight: 900, color: "white" }}>
                                                    {currentPraticante.nome?.charAt(0).toUpperCase()}
                                                </span>
                                            )}
                                        </div>
                                    </Col>
                                    <Col xs={12} sm>
                                        <h3 style={{ color: "white", fontWeight: 800, fontSize: 20, marginBottom: 8 }}>
                                            {currentPraticante.nome}
                                        </h3>
                                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                            <span className={`badge bg-${currentPraticante.isAtivo === 1 ? "success" : "warning"}`}>
                                                {currentPraticante.isAtivo === 1 ? "Ativo" : "Pendente de Aprovação"}
                                            </span>
                                            {(() => {
                                                const g = getGraduacaoInfo(currentPraticante.graduacao);
                                                return g ? (
                                                    <span className={`belt-badge ${g.className}`} style={{ fontSize: 11 }}>
                                                        {g.nome}
                                                    </span>
                                                ) : null;
                                            })()}
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* Secções de dados — grid 2 col desktop, 2 col mobile */}
                            {[
                                {
                                    titulo: "Dados Pessoais",
                                    campos: [
                                        { label: "Idade", value: `${calcularIdade(currentPraticante.dataNascimento)} anos` },
                                        { label: "Data Nascimento", value: currentPraticante.dataNascimento ? moment(currentPraticante.dataNascimento).format("DD/MM/YYYY") : "—" },
                                        { label: "Sexo", value: currentPraticante.sexo === 'M' ? "Masculino" : currentPraticante.sexo === 'F' ? "Feminino" : "—" },
                                        { label: "Telefone", value: currentPraticante.telefone },
                                        { label: "NIF", value: currentPraticante.nif },
                                        { label: "Cartão Cidadão", value: currentPraticante.cc },
                                        { label: "Nacionalidade", value: currentPraticante.nacionalidade },
                                        { label: "Naturalidade", value: currentPraticante.naturalidade },
                                    ]
                                },
                                {
                                    titulo: "Contacto e Morada",
                                    campos: [
                                        { label: "Email", value: currentPraticante.email, full: true },
                                        { label: "Morada", value: currentPraticante.morada, full: true },
                                        { label: "Localidade", value: currentPraticante.localidade },
                                        { label: "Código Postal", value: currentPraticante.cp },
                                    ]
                                },
                                {
                                    titulo: "Dados Federativos",
                                    campos: [
                                        { label: "Nº CPK", value: currentPraticante.n_CPK },
                                        { label: "Nº Federação", value: currentPraticante.n_Federacao },
                                    ]
                                },
                            ].map(secao => (
                                <div key={secao.titulo} className="mb-4">
                                    <h6 className="mb-3 text-primary fw-bold">{secao.titulo}</h6>
                                    <Row className="g-3">
                                        {secao.campos.map(campo => (
                                            <Col xs={campo.full ? 12 : 6} md={campo.full ? 12 : 3} key={campo.label}>
                                                <InfoItem label={campo.label} value={campo.value} />
                                            </Col>
                                        ))}
                                    </Row>
                                    <hr />
                                </div>
                            ))}

                            <div className="d-flex gap-2 mt-2">
                                <Button variant="outline-secondary" className="flex-grow-1" onClick={() => setShowModal(false)}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" className="flex-grow-1" onClick={() => setIsEditing(true)}>
                                    <FontAwesomeIcon icon={faEdit} className="me-2" /> Editar Perfil
                                </Button>
                            </div>
                        </>
                    )}

                    {/* ===== MODO FORMULÁRIO (Criação ou Edição) ===== */}
                    {(isEditing || isCreating) && (
                        <Form onSubmit={handleSave}>
                            <h6 className="mb-3 text-primary border-bottom pb-2">Dados Obrigatórios</h6>
                            <Form.Group className="mb-3">
                                <Form.Label>Nome Completo</Form.Label>
                                <Form.Control
                                    required
                                    placeholder="Nome do Praticante"
                                    value={currentPraticante.nome || ''}
                                    onChange={e => setCurrentPraticante({ ...currentPraticante, nome: e.target.value })}
                                />
                            </Form.Group>

                            <Row className="g-2">
                                <Col xs={12} sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Nascimento</Form.Label>
                                        <Form.Control
                                            type="date"
                                            required
                                            value={currentPraticante.dataNascimento || ''}
                                            onChange={e => setCurrentPraticante({ ...currentPraticante, dataNascimento: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={6} sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Sexo</Form.Label>
                                        <Form.Select
                                            required
                                            value={currentPraticante.sexo || ''}
                                            onChange={e => setCurrentPraticante({ ...currentPraticante, sexo: e.target.value })}
                                        >
                                            <option value="">Selecione...</option>
                                            <option value="M">Masculino</option>
                                            <option value="F">Feminino</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col xs={6} sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Telefone</Form.Label>
                                        <Form.Control
                                            type="tel"
                                            required
                                            value={currentPraticante.telefone || ''}
                                            onChange={e => setCurrentPraticante({ ...currentPraticante, telefone: e.target.value })}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {isEditing && (
                                <>
                                    <hr />
                                    <h6 className="mb-3 text-primary border-bottom pb-2">Identificação e Origem</h6>
                                    <Row className="g-2">
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>NIF</Form.Label>
                                                <Form.Control type="number" placeholder="Contribuinte"
                                                    value={currentPraticante.nif || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, nif: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cartão Cidadão</Form.Label>
                                                <Form.Control placeholder="Nº Documento"
                                                    value={currentPraticante.cc || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, cc: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nacionalidade</Form.Label>
                                                <Form.Control placeholder="Ex: Portuguesa"
                                                    value={currentPraticante.nacionalidade || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, nacionalidade: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Naturalidade</Form.Label>
                                                <Form.Control placeholder="Natural de..."
                                                    value={currentPraticante.naturalidade || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, naturalidade: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <hr />
                                    <h6 className="mb-3 text-primary border-bottom pb-2">Dados Federativos e Contacto</h6>
                                    <Row className="g-2">
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nº CPK</Form.Label>
                                                <Form.Control type="number"
                                                    value={currentPraticante.n_CPK || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, n_CPK: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nº Federação</Form.Label>
                                                <Form.Control type="number"
                                                    value={currentPraticante.n_Federacao || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, n_Federacao: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control type="email"
                                                    value={currentPraticante.email || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, email: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} sm={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Morada</Form.Label>
                                                <Form.Control
                                                    value={currentPraticante.morada || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, morada: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={7} sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Localidade</Form.Label>
                                                <Form.Control
                                                    value={currentPraticante.localidade || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, localidade: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5} sm={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cód. Postal</Form.Label>
                                                <Form.Control
                                                    value={currentPraticante.cp || ''}
                                                    onChange={e => setCurrentPraticante({ ...currentPraticante, cp: e.target.value })} />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <hr />
                                    <h6 className="mb-3 text-primary border-bottom pb-2">Fotografia de Perfil</h6>
                                    <div className="d-flex align-items-center bg-light p-3 rounded border mb-3">
                                        {fotoPreview && (
                                            <img src={fotoPreview} alt="Preview" className="me-3 rounded border shadow-sm"
                                                style={{ width: 56, height: 56, objectFit: "cover", borderRadius: "50%" }} />
                                        )}
                                        <Form.Control type="file" accept="image/*" onChange={handleFotoChange} className="bg-white" />
                                    </div>
                                </>
                            )}

                            <div className="d-flex gap-2 border-top pt-3">
                                <Button variant="outline-secondary" className="flex-grow-1"
                                    onClick={() => setShowModal(false)}>Cancelar</Button>
                                <Button variant="primary" type="submit" className="flex-grow-1" disabled={isProcessingFoto}>
                                    {isProcessingFoto ? (
                                        <><Spinner animation="border" size="sm" className="me-2" /> A processar...</>
                                    ) : isCreating ? "Submeter Inscrição" : "Guardar Alterações"}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}
